import { Box } from "@chakra-ui/react";
import { useEffect, useMemo } from "react";
import { AccountCard } from "../account/AccountCard";
import { useAPI } from "../api/useAPI";
import { useAPIQuery } from "../api/useAPIQuery";
import { useToastOnAPIError } from "../api/useToastOnAPIError";
import { SkeletonList } from "../utils/SkeletonList";

export const LeadersPanel = () => {
  const api = useAPI();
  const { data, state, error, query } = useAPIQuery({
    apiCall: api.accountGet,
  });
  useToastOnAPIError({
    error,
    title: "Unable to get Leaders",
  });
  const accounts = useMemo(() => data?.accounts ?? [], [data?.accounts]);

  useEffect(() => {
    query({});
  }, [query]);

  return (
    <Box>
      {state === "success" ? (
        <Box display={"flex"} flexDir={"column"}>
          {accounts.map((account) => (
            <AccountCard key={account.id} account={account} />
          ))}
        </Box>
      ) : (
        <SkeletonList height={20} items={3} />
      )}
    </Box>
  );
};
